/* ============================================================================
   RH Discount Codes (Cart) — FULL SCRIPT (NO POPUP)
   ✅ Prevents discount AMOUNT (e.g. -$3,759.00) from being treated as a code
   ✅ Keeps state.codes clean (codes only)
   ✅ Shows "Please enter a valid promo code." even if .caption doesn’t exist
      (creates .caption inside .rh-coupon-wrapper)
   ✅ Clear hint/caption on focus (separate guarded listener)
   ============================================================================ */

(function () {
  if (window.__RH_DISCOUNT_INITED__) return;
  window.__RH_DISCOUNT_INITED__ = true;

  const routesRoot =
    (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  const state = (window.__RH_DISCOUNT_STATE__ ||= { codes: [] });
  const norm = (s) => (s || '').trim().toLowerCase();

  function getRoot() {
    return document.querySelector('[data-rh-coupon]');
  }

  function getEls(root) {
    if (!root) return {};
    return {
      root,
      input: root.querySelector('#rh-discount-code'),
      applyBtn: root.querySelector('[data-rh-apply]'),
      hint: root.querySelector('[data-rh-hint]')
    };
  }

  function setHint(text) {
    const root = getRoot();
    const { hint } = getEls(root);
    if (hint) hint.textContent = text || '';
  }

  // ✅ Caption setter (creates .caption if missing)
  function setCaption(text, rootEl) {
    const root = rootEl || getRoot() || document;

    const wrapper =
      (root.querySelector && root.querySelector('.rh-coupon-wrapper')) ||
      document.querySelector('[data-rh-coupon] .rh-coupon-wrapper') ||
      document.querySelector('.rh-coupon-wrapper');

    if (!wrapper) return;

    let cap = wrapper.querySelector('.caption');
    if (!cap) {
      cap = document.createElement('div');
      cap.className = 'caption';
      wrapper.appendChild(cap);
    }

    cap.textContent = text || '';
    cap.classList.remove('hidden');
  }

  // ✅ Read applied codes from DOM (targets your two HTML patterns)
  // FIXED: avoids grabbing discount amount as a code
  function getAppliedCodesFromDom() {
    const codes = new Set();

    // 1) Custom list: ONLY read from data-coupon-name
    document
      .querySelectorAll('.rh-cart-remove-coupon-buttom[data-coupon-name]')
      .forEach((el) => {
        const v = (el.getAttribute('data-coupon-name') || '').trim();
        if (v) codes.add(v);
      });

    // 2) Fallback list: Promo Code label + code span
    // EXCLUDE: ul.rh-cart-applied-coupons (your custom list)
    document
      .querySelectorAll('ul.discounts[aria-label="Discount"]:not(.rh-cart-applied-coupons) li.discounts__discount')
      .forEach((li) => {
        const spans = li.querySelectorAll(':scope > span');
        if (spans.length < 2) return;

        const label = (spans[0].textContent || '').trim();
        if (!/promo\s*code/i.test(label)) return;

        const v = (spans[1].textContent || '').trim();
        if (!v) return;

        // Safety: ignore money-like strings
        if (/[$€£]/.test(v) || /^-/.test(v)) return;

        codes.add(v);
      });

    return Array.from(codes);
  }

  function nextFrame() {
    return new Promise((r) => requestAnimationFrame(() => r()));
  }

  // ✅ Spinner toggle
  function setLoading(isLoading, rootEl) {
    const root = rootEl || getRoot();
    if (!root) return;

    // If your spinner isn't a DIRECT child, change to:
    // const spinner = root.querySelector('.rh-coupon-wrapper .loading__spinner');
    const spinner = root.querySelector('.rh-coupon-wrapper > .loading__spinner');
    if (!spinner) return;

    spinner.classList.toggle('hidden', !isLoading);
  }

  function dispatchUpdated(extra) {
    window.dispatchEvent(new CustomEvent('rh:discounts-updated', {
      detail: { codes: state.codes.slice(), ...extra }
    }));
  }

  async function getCart() {
    const res = await fetch(routesRoot + 'cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    return res.json();
  }

  function extractDiscountCodes(cart) {
    const dc = cart && cart.discount_codes;
    if (Array.isArray(dc)) {
      return dc
        .map(x => (typeof x === 'string' ? x : (x && (x.code || x.title))))
        .filter(Boolean);
    }
    return [];
  }

  function sectionIdFromElement(el) {
    if (!el) return null;
    const host = el.closest('[id^="shopify-section-"]');
    if (!host) return null;
    return host.id.replace('shopify-section-', '');
  }

  function findCartSectionIds() {
    const ids = [];

    const itemsEl =
      document.querySelector('cart-items[data-id]') ||
      document.querySelector('[data-id*="__cart-items"]') ||
      document.querySelector('[data-id*="cart-items"]');

    const footerEl =
      document.querySelector('cart-footer[data-id]') ||
      document.querySelector('[data-id*="__cart-footer"]') ||
      document.querySelector('[data-id*="cart-footer"]');

    if (itemsEl?.dataset?.id) ids.push(itemsEl.dataset.id);
    if (footerEl?.dataset?.id) ids.push(footerEl.dataset.id);

    const couponSection = sectionIdFromElement(document.querySelector('[data-rh-coupon]'));
    if (couponSection) ids.push(couponSection);

    const appliedListSection = sectionIdFromElement(document.querySelector('.rh-cart-applied-coupons'));
    if (appliedListSection) ids.push(appliedListSection);

    return Array.from(new Set(ids)).filter(Boolean);
  }

  function applySectionsHtml(sections) {
    if (!sections || typeof sections !== 'object') return;

    Object.keys(sections).forEach((sectionId) => {
      const host = document.getElementById(`shopify-section-${sectionId}`);
      if (!host) return;

      const html = sections[sectionId];
      try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(`#shopify-section-${sectionId}`);
        host.innerHTML = fresh ? fresh.innerHTML : html;
      } catch (e) {
        host.innerHTML = html;
      }
    });
  }

  async function setDiscountCodes(codesArray) {
    const discountString = (codesArray || []).filter(Boolean).join(',');
    const sectionIds = findCartSectionIds();

    const payload = { discount: discountString };

    if (sectionIds.length) {
      payload.sections = sectionIds;
      payload.sections_url = window.location.pathname;
    }

    const res = await fetch(routesRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.description || 'Could not update discount codes.');
    return data;
  }

  async function refresh() {
    try {
      const cart = await getCart();
      state.codes = extractDiscountCodes(cart);
      dispatchUpdated({ cart });
    } catch (e) {
      dispatchUpdated({ error: e });
    }
  }

  function filterSafeCodes(arr) {
    return (arr || [])
      .map(x => (x || '').toString().trim())
      .filter(Boolean)
      .filter(v => !/[$€£]/.test(v))
      .filter(v => !/^-/.test(v));
  }

  async function apply(code) {
    const clean = (code || '').trim();
    if (!clean) {
      setCaption('Please enter a valid promo code.', getRoot());
      return;
    }

    setHint('');
    setCaption('', getRoot());

    const safeCodes = filterSafeCodes(state.codes);

    const exists = safeCodes.some(c => norm(c) === norm(clean));
    const next = exists ? safeCodes : safeCodes.concat([clean]);

    const root = getRoot();
    const { applyBtn } = getEls(root);

    setLoading(true, root);
    if (applyBtn) applyBtn.disabled = true;

    try {
      const data = await setDiscountCodes(next);

      if (data.sections) applySectionsHtml(data.sections);

      await nextFrame();

      const appliedDomCodes = filterSafeCodes(getAppliedCodesFromDom());
      const isApplied = appliedDomCodes.some(c => norm(c) === norm(clean));

      state.codes = appliedDomCodes;

      const rootNow = getRoot() || root;

      if (!isApplied) {
        setCaption('Please enter a valid promo code.', rootNow);
        dispatchUpdated({ data, invalid: true, attempted: clean });
        return;
      }

      setCaption('', rootNow);
      setHint('');
      dispatchUpdated({ data });
    } catch (e) {
      setCaption('Please enter a valid promo code.', getRoot() || root);
      dispatchUpdated({ error: e });
    } finally {
      setLoading(false, getRoot() || root);

      const freshRoot = getRoot() || root;
      const { applyBtn: freshBtn } = getEls(freshRoot);
      if (freshBtn) freshBtn.disabled = false;
      else if (applyBtn) applyBtn.disabled = false;
    }
  }

  async function remove(code) {
    const clean = (code || '').trim();
    if (!clean) return;

    setHint('');
    setCaption('', getRoot());

    const safeCodes = filterSafeCodes(state.codes);
    const next = safeCodes.filter(c => norm(c) !== norm(clean));

    try {
      const data = await setDiscountCodes(next);

      if (data.sections) applySectionsHtml(data.sections);
      await nextFrame();

      state.codes = filterSafeCodes(getAppliedCodesFromDom());
      dispatchUpdated({ data });
    } catch (e) {
      setHint('Could not remove that code.');
      dispatchUpdated({ error: e });
    }
  }

  async function clear() {
    try {
      const data = await setDiscountCodes([]);

      if (data.sections) applySectionsHtml(data.sections);
      await nextFrame();

      state.codes = filterSafeCodes(getAppliedCodesFromDom());
      dispatchUpdated({ data });
    } catch (e) {
      setHint('Could not clear discount codes.');
      dispatchUpdated({ error: e });
    }
  }

  // Expose API
  window.RHDiscount = {
    apply,
    remove,
    clear,
    refresh,
    getCodes: () => state.codes.slice()
  };

  // ✅ APPLY click
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rh-apply]');
    if (!btn) return;

    const root = btn.closest('[data-rh-coupon]');
    const { input } = getEls(root);
    apply(input?.value || '');
  });

  // ✅ Enter key in input
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('#rh-discount-code');
    if (!input) return;
    e.preventDefault();
    apply(input.value || '');
  });

  // ✅ REMOVE click (your spans)
  document.addEventListener('click', (e) => {
    const el = e.target.closest('.rh-cart-remove-coupon-buttom[data-coupon-name]');
    if (!el) return;

    const code = el.getAttribute('data-coupon-name') || '';
    if (!code) return;

    el.style.pointerEvents = 'none';
    remove(code).finally(() => { el.style.pointerEvents = ''; });
  });

  // Initial sync
  refresh();
})();

/* ============================================================================
   Clear message when user focuses input
   - Separate guard prevents double-binding
   ============================================================================ */
(function () {
  if (window.__RH_COUPON_CLEAR_INITED__) return;
  window.__RH_COUPON_CLEAR_INITED__ = true;

  document.addEventListener('focusin', (e) => {
    const input = e.target.closest('#rh-discount-code');
    if (!input) return;

    const root = input.closest('[data-rh-coupon]') || document;

    const wrapper =
      root.querySelector('.rh-coupon-wrapper') ||
      document.querySelector('[data-rh-coupon] .rh-coupon-wrapper') ||
      document.querySelector('.rh-coupon-wrapper');

    if (wrapper) {
      const caption = wrapper.querySelector('.caption');
      if (caption) caption.textContent = '';
    }

    const hint = root.querySelector('[data-rh-hint]');
    if (hint) hint.textContent = '';
  }, true);
})();
